import { render, staticRenderFns } from "./CoordTransform.vue?vue&type=template&id=ed2e3c66&scoped=true"
import script from "./CoordTransform.vue?vue&type=script&lang=js"
export * from "./CoordTransform.vue?vue&type=script&lang=js"
import style0 from "./CoordTransform.vue?vue&type=style&index=0&id=ed2e3c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2e3c66",
  null
  
)

export default component.exports